/* istanbul ignore file */
export const getListingDeleteModalState = (state) => state.tripboard.listingDeleteModal;


// WEBPACK FOOTER //
// ./src/universal/tripboard/listing-delete-modal/selectors.js